<template>
    <!-- The calendar's shell, built to the same contract as the mailbox's
         (layouts/Mail.vue): the panes fill the window, nothing scrolls but the
         panes themselves, and the layout paints nothing — the canvas is the
         body rule in theme/theme.css. -->
    <div class="h-dvh w-screen overflow-hidden text-default">
        <slot />
    </div>
</template>
